import { useEffect, useState } from "react";
import { getAllModulos } from "../../../services/modulo.service";
import { getAllIdiomas } from "../../../services/idioma.service";
import { ModuloList } from "../../../modules/modulo/ModuloList";
import { showErrorAlert } from "../../../components/molecules/ShowAlert";
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";

export const ModuloPage = () => {
  const [modulos, setModulos] = useState([]);

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    try {
      const [modulosApi, idiomasApi] = await Promise.all([
        getAllModulos(),
        getAllIdiomas(),
      ]);

      const modulosConIdioma = modulosApi.map((modulo) => {
        const idiomaEncontrado = idiomasApi.find(
          (idioma) => idioma.idIdioma === modulo.idIdioma
        );
        return {
          ...modulo,
          idioma: idiomaEncontrado || { nombre: "Sin idioma" },
        };
      });

      setModulos(modulosConIdioma);
    } catch (error) {
      console.error("Error al cargar módulos e idiomas:", error);
      showErrorAlert({ text: "Error al cargar los módulos o idiomas." });
    }
  };

  return (
    <ContenedorPageTemplate titulo="Listado de Módulos">
      <ModuloList modulos={modulos} />
    </ContenedorPageTemplate>
  );
};
